import axios from "axios";
import BaseApiCall from "./BaseApiCall";
import apiConfig from "../api/apiConfig";
// app.use(cors({ origin: 'http://localhost:3000' }));

export const login = async (username, password) => {
    try {
        const response = await axios.post(apiConfig.baseUrl + '/auth/login', {
            username,
            password,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Login error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};


export const logout = async (access_token) => {
    try {
        const response = await axios.post(apiConfig.baseUrl + '/auth/logout', {
            access_token,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        console.log('API response:', response);
        return response.data;
    } catch (error) {
        console.error('Logout error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const loadOrg = async () => {
    try {
        const response = await BaseApiCall.get('/settings/load-org');
        return response.data;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const organizationList = async () => {
    try {
        const response = await BaseApiCall.post('/settings/org-list');
        return response;
    } catch (error) {
        console.error('Error loading organization:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const defaultSearch = async (username) => {
    try {
        const response = await BaseApiCall.post('/tickets/search-by-query', { q: username });
        return response;
    } catch (error) {
        console.error('Error loading organization:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}
